import { useEffect, useState } from 'react';

/**
 * Tracks the browser's online/offline state. Useful for surfacing a
 * banner and for choosing a friendlier message when an event POST
 * fails because the venue wifi blipped — the PWA service worker
 * (vite.config.ts) queues those POSTs and replays on reconnect, so
 * "queued" is a more honest message than "failed".
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState(
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );
  useEffect(() => {
    function on() {
      setOnline(true);
    }
    function off() {
      setOnline(false);
    }
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}
